var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkingDays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M21.9998 14V12C21.9998 11.161 21.9868 9.665 21.9738 9H2.00578C1.99278 9.665 2.00578 11.161 2.00578 12V14C2.00578 17.771 2.00578 19.657 3.17578 20.828C4.34878 22 6.23378 22 10.0038 22H14.0038C17.7738 22 19.6578 22 20.8298 20.828C21.9998 19.657 21.9998 17.771 21.9998 14Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96 2C7.378 2 7.716 2.31 7.716 2.692V4.09C8.386 4.078 9.138 4.078 9.984 4.078H14.016C14.862 4.078 15.613 4.078 16.284 4.09V2.692C16.284 2.31 16.622 2 17.04 2C17.458 2 17.796 2.31 17.796 2.692V4.15C19.246 4.256 20.199 4.518 20.899 5.158C21.599 5.799 21.884 6.671 22 8V9H2V8C2.116 6.671 2.401 5.8 3.101 5.158C3.801 4.518 4.753 4.256 6.204 4.15V2.692C6.204 2.31 6.543 2 6.96 2Z",
    fill: "#637381"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.5C13.6569 18.5 15 17.1569 15 15.5C15 13.8431 13.6569 12.5 12 12.5C10.3431 12.5 9 13.8431 9 15.5C9 17.1569 10.3431 18.5 12 18.5Z",
    stroke: "#637381",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14V15.5L12.75 16.25",
    stroke: "#637381",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingDays);
export default __webpack_public_path__ + "static/media/working-days.1858fb08b417811e2cf9cf20ec736aa6.svg";
export { ForwardRef as ReactComponent };